// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"540\" height=\"540\" viewBox=\"0 0 540 540\"> <path fill=\"#e8423f\" d=\"M0 0h540v540H0z\"/> <path fill=\"#fff\" d=\"M0 0h360v540H0z\"/> <path fill=\"#16a74e\" d=\"M0 0h180v540H0z\"/> <path d=\"M450 20v140m-70-70h140\" stroke=\"#fff\" stroke-width=\"20\"/> </svg> ";
// Exports
module.exports = code;